import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addVendor, fetchVendors } from '../../../features/vendors';
import { VendorCreate } from '../../../features/vendors/types';
import { validateVendorForm } from '../../../features/vendors/validation';
import { useFormValidation } from '../../../hooks/useFormValidation';

const initialValues: VendorCreate = {
  name: '',
  contact_person: '',
  phone: '',
  email: '',
  address: ''
};

export const useVendorForm = (onSuccess: () => void) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);

  const { values, errors, handleChange, handleSubmit, isValid } = useFormValidation(
    initialValues,
    validateVendorForm,
    async (values) => {
      setIsSubmitting(true);
      setSubmitError(null);
      try {
        await dispatch(addVendor(values));
        await dispatch(fetchVendors());
        onSuccess();
      } catch (error) {
        const message = error instanceof Error ? error.message : 'Failed to add vendor';
        setSubmitError(message);
        throw error;
      } finally {
        setIsSubmitting(false);
      }
    }
  );

  return {
    values,
    errors,
    handleChange,
    handleSubmit,
    isValid,
    isSubmitting,
    submitError
  };
};